const heroVideoBannerDesktopBlocks = document.querySelectorAll(
	'.block-hero-video-banner-desktop'
);

if (heroVideoBannerDesktopBlocks.length > 0) {
	heroVideoBannerDesktopBlocks.forEach((block) => {
		const pauseButton = block.querySelector(
			'.block-hero-video-banner-desktop__pause-button'
		);

		if (pauseButton) {
			pauseButton.addEventListener('click', () => {
				const video = block.querySelector('video');
				if (!video) return;

				if (video.paused) {
					video.play();
					pauseButton.classList.remove('is-paused');
					pauseButton.setAttribute(
						'aria-label',
						'Pause background video'
					);
				} else {
					video.pause();
					pauseButton.classList.add('is-paused');
					pauseButton.setAttribute(
						'aria-label',
						'Play background video'
					);
				}
			});
		}
	});
}
